import { render } from "./OrderStagedOrderCard.vue?vue&type=template&id=18838c9b"
import script from "./OrderStagedOrderCard.vue?vue&type=script&lang=js"
export * from "./OrderStagedOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__